
$(document).ready(function () {
    $('.whiskys_lide_image').slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  autoplay:false,
  dots: true,
  prevArrow:'<button type="button" class="slick-prev pull-left"><svg xmlns="http://www.w3.org/2000/svg" width="15" height="26" viewBox="0 0 15 26" fill="none"><path d="M13 24L2.70711 13.7071C2.31658 13.3166 2.31658 12.6834 2.70711 12.2929L13 2" stroke="#FEBC9B" stroke-width="3" stroke-linecap="round"/></svg></button>',
  nextArrow:'<button type="button" class="slick-next pull-right"><svg xmlns="http://www.w3.org/2000/svg" width="15" height="26" viewBox="0 0 15 26" fill="none"><path d="M2 24L12.2929 13.7071C12.6834 13.3166 12.6834 12.6834 12.2929 12.2929L2 2" stroke="#FEBC9B" stroke-width="3" stroke-linecap="round"/></svg></button>',
  responsive: [                        
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 1,
        }
      },
  ]
});
  })
$(document).ready(function () {
 if ($(window).width() < 768) {
        $('.slide_grid_mobile').slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  autoplay:false,
  dots: true,
  responsive: [                        
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      },
  ]
});
}
})
$(document).ready(function () {


      // $('.slide_grid_mobile_new').slick({
      //   infinite: true,
      //   slidesToShow: 1,
      //   slidesToScroll: 1,
      //   arrows: false,
      //   autoplay: false,
      //   dots: true,
      //   responsive: [
      //     {
      //       breakpoint: 769,
      //       settings: {
      //         slidesToShow: 1,
      //         slidesToScroll: 1,
      //       }
      //     },
      //   ]
      // });
   // Delay the initialization by 1000ms (1 second)
// document.addEventListener('shopify:section:load', function(event) {
//   if (event.detail.sectionId.includes('product-recommendations')) {
//     $('.slide_grid_mobile_new').slick({ 
//               infinite: true,
//         slidesToShow: 1,
//         slidesToScroll: 1,
//         arrows: false,
//         autoplay: false,
//         dots: true,
//         responsive: [
//           {
//             breakpoint: 769,
//             settings: {
//               slidesToShow: 1,
//               slidesToScroll: 1,
//             }
//           },
//         ]
//     });
//   }
// });
});

  $(document).ready(function () {
    $('.top-brand-section.mob_slider .custom-content').slick({
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  arrows: false,
  autoplay:true,
  dots: false,
  responsive: [                        
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 3,
        }
      },
  ]
});
  })
  $(document).ready(function () {
    $('.slider_in_dektop').slick({
  infinite: false,
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: true,
  autoplay:false,
  dots: false,
  prevArrow:'.custom_left',
  nextArrow:'.custom_right',
      responsive: [  
           {
        breakpoint: 1034,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        }
      },
  ]
});
       $('.banner_mobile_products').slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  autoplay:false,
  dots: true,
  responsive: [                        
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 1,
        }
      },
  ]
});
$(document).on('click','.header-item--search .site-nav__compress-menu',function(){
  $('.header-item.header-item--icons button.site-nav__link.site-nav__link--icon.medium-up--hide.mobile-nav-trigger').trigger('click')
})

// $(document).on('click','.filter_close_btn',function(){
//   $('body.overflow_scroll').removeClass('overflow_hide');
//   // $('body').addClass('overflow_scroll')
//   $('.collection-filter__btn').trigger('click')
// })
// $(document).on('click','.filter-grid .tag',function(){
// $('body').removeClass('overflow_hide');
// })
// $(document).on('click','.filter-grid .collapsible-content',function(){
// $('body').removeClass('overflow_hide');
// })


  })
$(document).ready(function () {
  setTimeout(function () {
    $('.new_hide_tab').hide();
  }, 3000); // 3000 milliseconds = 3 seconds
});
        $('.slider_tse_dotes').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  autoplay:true,
  dots: true,
  prevArrow:'<button type="button" class="slick-prev pull-left"><svg xmlns="http://www.w3.org/2000/svg" width="15" height="26" viewBox="0 0 15 26" fill="none"><path d="M13 24L2.70711 13.7071C2.31658 13.3166 2.31658 12.6834 2.70711 12.2929L13 2" stroke="#FEBC9B" stroke-width="3" stroke-linecap="round"/></svg></button>',
  nextArrow:'<button type="button" class="slick-next pull-right"><svg xmlns="http://www.w3.org/2000/svg" width="15" height="26" viewBox="0 0 15 26" fill="none"><path d="M2 24L12.2929 13.7071C12.6834 13.3166 12.6834 12.6834 12.2929 12.2929L2 2" stroke="#FEBC9B" stroke-width="3" stroke-linecap="round"/></svg></button>',
  responsive: [                        
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      },
  ]
});

$(document).ready(function () {
    $('.new_slider_track_cstm').slick({
  infinite: false,
  slidesToShow: 4,
  slidesToScroll: 1,
  arrows: true,
  autoplay:false,
  dots: false,
   prevArrow: $('.arrow.left'),
  nextArrow: $('.arrow.right'),
  responsive: [                        
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 1,
          dots: true,
          arrows: false,
        }
      },
  ]
});
  })
$(document).ready(function () {
    $('.new_impe_slider').slick({
  infinite: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  autoplay:false,
  dots: false,
   prevArrow: $('.impe-arrow.left'),
  nextArrow: $('.impe-arrow.right'),
  responsive: [                        
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 1,
          dots: true,
          arrows: false,
        }
      },
  ]
});
  })